import React from 'react';
import { Navbar, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const MeancLogo = () => (
  <div className="meanc-logo">
    <div className="meanc-logo-icon">
      <span>M</span>
      <span>E</span>
    </div>
    <div className="meanc-logo-type">
      <strong>MEANC</strong>
      <small>means connected</small>
    </div>
  </div>
);

export default function Header5() {
  return (
    <Navbar
      expand={false}
      bg="light"
      className="custom-navbar align-items-left fixed-top"
      style={{ boxShadow: '0px 12px 30px rgba(0, 0, 0, 0.12)' }}
    >
      <Container>
        <Navbar.Brand style={{ marginLeft: '10px' }}>
          <Link to="/" className="meanc-logo-link">
            <MeancLogo />
          </Link>
        </Navbar.Brand>
        <nav className="top-nav">
          <a className="top-nav__link" href="/#products">Products</a>
          <a className="top-nav__link" href="https://smartamenity.net" target="_blank" rel="noreferrer">Smart Amenity</a>
          <a className="top-nav__link" href="/#about">About</a>
          <a className="top-nav__link" href="/#contact">Contact</a>
          <Link className="top-nav__cta" to="/access-lab">Get access</Link>
        </nav>
      </Container>
    </Navbar>
  );
}
